import { Field } from 'formik'
import React from 'react'

import { Checkbox, Fieldset, InputUI, RadioButton } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { SideSummary } from '../../../../../../../components/common/SideSummary'
import type { PostAccess as PostAccessType } from '../../../../types'
import type { Tier } from '../../../Perks/hooks/useTiers'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'

type Props = {
  tiers: Tier[]
  showNotification?: boolean
  disabled?: boolean
}

export const PostAccess = ({ tiers, showNotification = false, disabled }: Props) => {
  const { values, errors } = useFormikContext<FormValues>()

  const renderTiers = () => {
    if (values.access !== 'Plans') {
      return null
    }

    return (
      <>
        {tiers.map((tier) => (
          <Fieldset.Row inner>
            <Field
              name={`tierIds.${tier.id}`}
              component={Checkbox}
              label={tier.title}
              disabled={disabled}
            />
          </Fieldset.Row>
        ))}
      </>
    )
  }

  return (
    <>
      <SideSummary.Item title="Who can access this post?">
        <Fieldset>
          <Fieldset.Row>
            <Field
              component={RadioButton}
              name={FormFields.access}
              checkedValue={'MembersOnly' satisfies PostAccessType}
              label="Members only"
              disabled={disabled}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <Field
              component={RadioButton}
              name={FormFields.access}
              checkedValue={'FreeMembers' satisfies PostAccessType}
              label="Free accounts only"
              disabled={disabled}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <Field
              component={RadioButton}
              name={FormFields.access}
              checkedValue={'FreeAndPaidMembers' satisfies PostAccessType}
              label="Members & free accounts"
              disabled={disabled}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <Field
              component={RadioButton}
              name={FormFields.access}
              checkedValue={'Plans' satisfies PostAccessType}
              label="Selected tiers"
              disabled={disabled}
            />
          </Fieldset.Row>
          {renderTiers()}
          {/* @ts-ignore */}
          {errors.tierIds && <InputUI.Error>{errors.tierIds}</InputUI.Error>}
          <Fieldset.Row>
            <Field
              component={RadioButton}
              name={FormFields.access}
              checkedValue={'Public' satisfies PostAccessType}
              label="Public (everyone)"
              tooltip="Anyone can see this post, even if they are not a member"
              disabled={disabled}
            />
          </Fieldset.Row>
        </Fieldset>
      </SideSummary.Item>

      {showNotification && (
        <SideSummary.Item title="Notifications">
          <Field
            name={FormFields.notifyMembers}
            component={Checkbox}
            label="Notify members about this post"
            disabled={disabled}
          />
        </SideSummary.Item>
      )}
    </>
  )
}
